import { render, staticRenderFns } from "./ConnectionsCard.vue?vue&type=template&id=964f73a8&"
import script from "./ConnectionsCard.vue?vue&type=script&lang=js&"
export * from "./ConnectionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('964f73a8')) {
      api.createRecord('964f73a8', component.options)
    } else {
      api.reload('964f73a8', component.options)
    }
    module.hot.accept("./ConnectionsCard.vue?vue&type=template&id=964f73a8&", function () {
      api.rerender('964f73a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/cards/ConnectionsCard.vue"
export default component.exports